import { AppUserDto, UserRole } from '../services/api.services';
import { UserRef } from '../shared/models/UserRef';

export class AppUserWrapper {
  constructor(public readonly user: AppUserDto) { }

  get id() { return this.user.id; }
  get username() { return this.user.username; }

  get role() { return this.user.role; }
  get isBusinessUser() { return this.user.role <= UserRole.ClientUser; }
  get isInsightsUser() { return this.user.role >= UserRole.InsightsUser; }
  get isSupportAdmin() { return this.user.role >= UserRole.ClientAdmin; }
  get isSuperAdmin() { return this.user.role >= UserRole.InsightsAdmin; }
  get isDeveloper() { return this.user.role >= UserRole.Developer; }

  hasRole(role: UserRole) {
    return this.user.role >= role;
  }

  get organisation() { return this.user.organisationDisplayName; }
  get organisationId() { return this.user.organisationId; }

  get region() { return this.user.region; }

  get isImpersonating() { return !!this.user.impersonation; }

  get ref(): UserRef {
    return {
      id: this.id,
      name: this.username
    };
  }
}

export function getUserRoleDisplayName(userRole: UserRole) {
  switch (userRole) {
    case UserRole.ClientUser: return 'Business User';
    case UserRole.ClientAdmin: return 'Admin';
    case UserRole.InsightsUser: return 'Support Admin';
    case UserRole.InsightsAdmin: return 'Super Admin';
    case UserRole.Developer: return 'Developer';
  }

  return 'undefined';
}
